const URL_BASE_DOWNLOAD = "webclient/sk_core/swf/CentrodeDescarga";
const URL_NO_SUPPORT = "/nosupport";
const URL_ORIGIN = "www.clarovideo.com";
const URL_IOS = "https://itunes.apple.com/app/clarovideo/id568894377?mt=8";
const URL_ANDROID =
  "https://play.google.com/store/apps/details?id=com.dla.android";

const userAgent = {
  none: 0,
  android: 1,
  ios: 2,
  mac: 3,
  windows: 4,
  linux: 5,
  windowsTen: 6
};

export const DEVICE_OS = [
  'none',
  'android',
  'ios',
  'mac',
  'windows',
  'linux',
  'windowsTen',
];

export const getPlatform = () => {
  const platform = navigator.platform.toUpperCase();
  if (navigator) {
    if (/android/i.test(navigator.userAgent)) {
      return userAgent.android;
    }
    if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
      return userAgent.ios;
    }
    if (/(Windows 10.0|Windows NT 10.0)/.test(navigator.userAgent)) {
      return userAgent.windowsTen;
    }
    if (platform.indexOf("MAC") !== -1) {
      return userAgent.mac;
    }
    if (platform.indexOf("WIN") !== -1) {
      return userAgent.windows;
    }
    if (platform.indexOf("LINUX") !== -1) {
      return userAgent.linux;
    }
  }
  return userAgent.none;
};

export const getDownloadLink = origin => {
  const platform = getPlatform();

  switch (platform) {
    case userAgent.windows:
      return `${origin}${URL_BASE_DOWNLOAD}.msi`;

    case userAgent.mac:
      return `${origin}${URL_BASE_DOWNLOAD}.pkg`;

    case userAgent.ios:
      return URL_IOS;

    case userAgent.android:
      return URL_ANDROID;

    case userAgent.linux:
    case userAgent.none:
    default:
      return URL_NO_SUPPORT;
  }
};

export const getDeepLink = (groupId, region) => {
  const platform = getPlatform();
  const deepLink = `dlaapk://${URL_ORIGIN}/${region}/catalogo?autoplay=${groupId}&showPlayer=false`;

  switch (platform) {
    case userAgent.windowsTen:
      return deepLink;

    case userAgent.ios:
      return deepLink;

    case userAgent.android:
      return deepLink;

    default:
      return null;
  }
};
